import { PageQueryParams } from '../../../types/api/api.types';
import { CONSULTATIONS_ENDPOINTS } from '../../../utils/api/endpoints/consultationsEndpoints';
import { UseCompanyConsultationsResponse } from './useCompanyConsultations.types';

const PREFIX = '[companyConsultationsQuery]';

export const queryCompanyConsultations = async (params: PageQueryParams) => {
  console.log(PREFIX, `Fetching company consultations...`);
  const response = await CONSULTATIONS_ENDPOINTS.allCompanyConsultations(params);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received company consultations.`);
  return json as UseCompanyConsultationsResponse;
};
